// extracted by mini-css-extract-plugin
export default {"pagination":"Utils_pagination__SgVwH","buttons":"Utils_buttons__ab2sA","skip":"Utils_skip__z9Kns","active":"Utils_active__gj5GQ","notActive":"Utils_notActive__sgouf"};